export default __webpack_public_path__ + "static/media/company_hierarchy.0c7cdc13.svg";